import { NextResponse } from "next/server";
import * as Constants from '@/utils/Constants/constants';
import { Cookies } from "next-client-cookies";
import ILoginResponse from "@/utils/Interfaces/ILoginResponse";
import * as jose from 'jose';

async function verifyJwsToken(jwsToken: string): Promise<boolean> {
    try {
        const pkRes = await fetch(Constants.APIBASEURL + "/access/getpublickey");
        let publicKeyPem = await pkRes.text();
        publicKeyPem = publicKeyPem.replace(/"/g, '').trim();

        const publicKey = await jose.importSPKI(publicKeyPem, 'RS256');
        await jose.compactVerify(jwsToken, publicKey);

        return true;
    } catch (err) {
        console.log("JWS verification error: " + err);
        return false;
    }
}

export default async function fetchLogin(req: string, cookieStore: Cookies) {
    try {
        const apiUri = await Constants.APIBASEURL + Constants.LOGIN_ENDPOINT;
        await console.log("base : " + apiUri)
        const headers = await {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Access-Control-Allow-Origin': '*',
        };

        console.log("request Json : " + await req);
        console.log("sending call to server ... ");

        var apiResponse = await fetch(apiUri, {
            method: 'POST',
            headers: headers,
            body: req
        }).then(async (resp) => {
            var res = resp;
            if (resp.status == 200) {

                const parsed = JSON.parse(req);
                const token = parsed.token;
                const emailPart = token.split(".")[0];
                cookieStore.set("ME", "" + emailPart, { secure: true, sameSite: "Strict" });

                console.log("Got data from server ...");
                const data = await res.json() as ILoginResponse;

                console.log("Setting res from data/response received | data : " + JSON.stringify(data));
                var retRes = await NextResponse.json(data, {
                    status: res.status,
                    headers: res.headers
                });

                console.log("Getting cookies from server ...")
                var serverCookies = await res.headers.getSetCookie();
                console.log("serverCookies : " + await JSON.stringify(serverCookies));
                var jws = await res.headers.get(Constants.X_JWS_SIGNATURE_HEADER) || data.xJws || "";

                if (!jws && data.msg === "Already login!") {
                    console.log("Already logged in — clearing session and retrying");
                    return NextResponse.json({
                        userType: Constants.LOGIN_USR_ACCESS_TYPE_NOT_IN,
                        msg: "Already logged in.",
                        loggedIn: false
                    }, { status: 200 });
                }

                if (!jws) {
                    console.log("No JWS token received — rejecting login");
                    return NextResponse.json({
                        userType: Constants.LOGIN_USR_ACCESS_TYPE_NOT_IN,
                        msg: "Authentication token missing",
                        loggedIn: false
                    }, { status: 401 });
                }

                const isJwsValid = await verifyJwsToken(jws);

                if (!isJwsValid) {
                    console.log("JWS verification failed — rejecting login");
                    return NextResponse.json({
                        userType: Constants.LOGIN_USR_ACCESS_TYPE_NOT_IN,
                        msg: "Authentication verification failed",
                        loggedIn: false
                    }, { status: 401 });
                }

                console.log("JWS verification passed ✅");

                if (serverCookies && serverCookies.length > 0) {
                    for (const cookie of serverCookies) {
                        const c = cookie.split('=');
                        console.log("Cookie : " + c[0], c[1]);
                        cookieStore.set(Constants.X_JWS_USER_ID, data.id, Constants.COOKIE_SECURE);
                        cookieStore.set(Constants.X_JWS_SIGNATURE_COOKIE, jws, Constants.COOKIE_SECURE);
                        cookieStore.set(c[0], c[1], Constants.COOKIE_SECURE);
                    }
                } else {
                    console.log("jws : " + jws);
                    cookieStore.set(Constants.LOGIN_USR_STTS_KEY, data.loggedIn ? Constants.LOGIN_USR_STTS_VAL_ACTIVE : Constants.LOGIN_USR_STTS_VAL_INACTIVE, Constants.COOKIE_SECURE);
                    cookieStore.set(Constants.LOGIN_USR_ACCESS_TYPE, data.userType ? data.userType : Constants.LOGIN_USR_ACCESS_TYPE_NOT_IN, Constants.COOKIE_SECURE);
                    cookieStore.set(Constants.USER_FULL_NAME, data.userName ? data.userName?.toLowerCase() : " ", Constants.COOKIE_SECURE);
                    cookieStore.set(Constants.X_JWS_USER_ID, data.id, Constants.COOKIE_SECURE);
                    cookieStore.set(Constants.X_JWS_SIGNATURE_COOKIE, jws, Constants.COOKIE_SECURE);
                }

                return retRes;

            } else {
                const data = await res.json() as ILoginResponse;

                console.log("Setting res from data/response received | data : " + JSON.stringify(data));
                var retRes = await NextResponse.json(data, {
                    status: res.status,
                    headers: res.headers
                });

                return retRes;
            }
        });

        return apiResponse;

    } catch (ex) {
        var errEx = ex;
        console.log("Exception occured: " + errEx)
        return NextResponse.json({
            userType: Constants.LOGIN_USR_ACCESS_TYPE_NOT_IN,
            msg: "Middleware Failure " + errEx,
            loggedIn: false
        }, {
            status: Constants.HTTP_STTS_CODE_500
        });
    }
}